<template>
    <div>
        <!-- Page Hero -->
        <section class="page-hero d-flex align-items-center justify-content-center text-center text-white position-relative"
            style="background-color: #333; height: 400px; overflow: hidden;">
            <img src="https://placehold.co/1920x400/333333/666666?text=Wishlist+Hero"
                class="position-absolute w-100 h-100 object-fit-cover opacity-50" alt="Hero">
            <div class="position-relative z-1">
                <h1 class="display-4 fw-bold font-serif mb-2">Wishlist</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a href="/"
                                class="text-white text-decoration-none small">Home</a></li>
                        <li class="breadcrumb-item active text-white-50 small" aria-current="page">Wishlist</li>
                    </ol>
                </nav>
            </div>
        </section>
        <div class="position-relative">
            <div class="torn-paper-edge"></div>
        </div>

        <!-- Main Content -->
        <section class="py-5 bg-light-creme">
            <div class="container mb-5">
                
                <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-brown" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>

                <div v-else-if="wishlistItems.length > 0">
                    <!-- Product Grid -->
                    <div class="row g-4">
                        <div class="col-md-6 col-lg-3" v-for="item in wishlistItems" :key="item.id">
                            <!-- Use ProductCard but ensure we map the structure correctly if needed -->
                            <!-- The API returns FavoriteResource which likely wraps the Product or has product data -->
                            <!-- Let's check FavoriteController output. It returns FavoriteResource collection of favorites. -->
                            <!-- We need to see what FavoriteResource returns. Usually it has a 'product' relation. -->
                            <!-- Assuming item.product is the product object compatible with ProductCard -->
                            <product-card :product="item.product" @add-to-cart="addToCart"></product-card>
                        </div>
                    </div>
                </div>

                <div v-else class="text-center py-5">
                    <div class="bg-white rounded-4 shadow-sm p-5 d-inline-block">
                        <i class="bi bi-heart text-muted fs-1 mb-3 d-block"></i>
                        <h3 class="fw-bold text-muted mb-4">Your wishlist is empty</h3>
                        <a href="/products" class="btn btn-brown rounded-pill px-4">Continue Shopping</a>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import ProductCard from './ProductCard.vue';

    export default {
        components: {
            ProductCard
        },
        data() {
            return {
                wishlistItems: [],
                loading: true
            }
        },
        mounted() {
            this.fetchWishlist();
            
            // Listen for updates (removing an item via the card toggle will emit this)
            window.Bus.$on('wishlist-updated', () => {
                this.fetchWishlist();
            });
        },
        methods: {
            fetchWishlist() {
                this.loading = true;
                axios.get('/api/frontend/wishlist')
                    .then(response => {
                        this.wishlistItems = response.data.data;
                    })
                    .catch(error => {
                        console.error('Error fetching wishlist:', error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            addToCart(product) {
                 axios.post('/api/frontend/cart/add', {
                    product_id: product.id,
                    quantity: 1 // Default to 1
                })
                .then(response => {
                     // Update cart count
                     // Assuming response returns cart data appropriate for count update
                     // or we just fetch count again
                     // Simple implementation:
                     window.Bus.$emit('cart-updated'); 
                     
                     this.$swal.fire({
                        icon: 'success',
                        title: 'Added to Cart!',
                        text: 'Product has been added to your cart.',
                        timer: 2000,
                        showConfirmButton: false,
                        toast: true,
                        position: 'top-end'
                    });
                })
                .catch(error => {
                    console.error('Error adding to cart:', error);
                     if (error.response && error.response.status === 401) {
                         window.location.href = '/customer/login';
                    }
                });
            }
        }
    }
</script>
